'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.apiInitialState = apiInitialState;
exports.apiRequest = apiRequest;
exports.apiSuccess = apiSuccess;
exports.apiFailure = apiFailure;
exports.apiInvalidate = apiInvalidate;
exports.default = apiReducer;

var _merge2 = require('lodash/merge');

var _merge3 = _interopRequireDefault(_merge2);

var _apiMiddleware = require('../middleware/apiMiddleware');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function apiInitialState() {
	return {
		isFetching: false,
		didInvalidate: true
	};
}

function apiRequest(state) {
	return _extends({}, state, {
		isFetching: true,
		hasError: false
	});
}

function apiSuccess(state, action) {
	return _extends({}, state, {
		data: action.response.result,
		isFetching: false,
		hasError: false,
		didInvalidate: false,
		lastUpdated: action.receivedAt
	});
}

function apiFailure(state) {
	return _extends({}, state, {
		isFetching: false,
		hasError: true,
		didInvalidate: false
	});
}

function apiInvalidate(state) {
	return _extends({}, state, {
		didInvalidate: true
	});
}

function apiReducer(_ref) {
	var type = _ref.type;
	var mapActionToKey = _ref.mapActionToKey;

	if (typeof type !== 'string') {
		throw new Error('Expected type to be a string.');
	}

	function updateApiState() {
		var state = arguments.length <= 0 || arguments[0] === undefined ? {
			isFetching: false,
			didInvalidate: true
		} : arguments[0];
		var action = arguments[1];

		switch (action.type) {
			case (0, _apiMiddleware.apiRequestType)(type):
				{
					return apiRequest(state);
				}
			case (0, _apiMiddleware.apiSuccessType)(type):
				{
					return apiSuccess(state, action);
				}
			case (0, _apiMiddleware.apiFailureType)(type):
				{
					return apiFailure(state);
				}
			default:
				return state;
		}
	}

	return function updateApiStateByKey() {
		var state = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
		var action = arguments[1];

		switch (action.type) {
			case (0, _apiMiddleware.apiRequestType)(type):
			case (0, _apiMiddleware.apiSuccessType)(type):
			case (0, _apiMiddleware.apiFailureType)(type):
				if (mapActionToKey) {
					var key = mapActionToKey(action);
					return (0, _merge3.default)({}, state, _defineProperty({}, key, updateApiState(state[key], action)));
				} else {
					return (0, _merge3.default)({}, state, updateApiState(state, action));
				}
			default:
				return state;
		}
	};
}


/*****************
 ** WEBPACK FOOTER
 ** ./~/ml-fetch/dist/reducer/apiReducer.js
 ** module id = 645
 ** module chunks = 0
 **/